import {apiUrl} from "../../../settings";

export const cambieAgentListUrl = () => {
    return apiUrl + '/cambie/agentList';
};

export const updateCambieAgentStatusUrl = () => {
    return apiUrl + '/cambie/updateAgentStatus';
};
